/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type AbsenceReason = typeof AbsenceReason[keyof typeof AbsenceReason];


export const AbsenceReason = {
  Vacation: 'Vacation',
  Illness: 'Illness',
  IllnessWithoutDoctorsNotice: 'IllnessWithoutDoctorsNotice',
  ChildSick: 'ChildSick',
  VacationHalfDay: 'VacationHalfDay',
  SpecialVacation: 'SpecialVacation',
  SpecialVacationHalfDay: 'SpecialVacationHalfDay',
  CompensatoryTimeOff: 'CompensatoryTimeOff',
  ParentalLeave: 'ParentalLeave',
  MaternityProtection: 'MaternityProtection',
  Exemption: 'Exemption',
} as const;
